export const SYNC_PROGRAM_OPTIONS = '@@programOptions/sync'

export const SET_PROGRAM_OPTIONS = '@@programOptions/set'

export const SET_PROGRAM_INITIAL_OPTIONS = '@@programOptions/setInitialOptions'
export const SET_PROGRAM_CURRENT_OPTIONS = '@@programOptions/setCurrentOptions'

export const SET_PROGRAM_OPTIONS_VALIDATION = '@@programOptions/setProgramOptionsValidation'
